import { useState } from 'react'
import { avatarColor, initials } from './projetosKit.jsx'

export default function PersonAvatar({ person }) {
  const [failed, setFailed] = useState(null)
  return <span className="oe-avatar" style={{ background: avatarColor(person.id) }} aria-hidden="true">
    {person.avatar_url && failed !== person.avatar_url
      ? <img src={person.avatar_url} alt="" onError={() => setFailed(person.avatar_url)} />
      : initials(person.nome)}
  </span>
}
